<template>
  <tab-item-template>
    <template #toolbar-items>
      <v-spacer/>
      <trade-contract-filter
          class="mr-2"
          @change="handleFilterChanged"
          @apply-filter="tradeContractFilter = $event"
          :status-filters="['showTrading', 'showSuspended', 'showPublic', 'showPrivate']"
          hide-direction-filters>
      </trade-contract-filter>
      <v-text-field
          v-model="filterText"
          clearable
          outlined
          dense
          placeholder="検索"
          light
          background-color="white"
          style="max-width: 300px;"
          hide-details>
      </v-text-field>
    </template>

    <el-table
        :data="tradeContractsViewFiltered"
        :default-sort="{prop: 'latestMessageCreatedAt', order: 'descending'}"
        border>
      <el-table-column
          width="120"
          prop="id"
          label="ID">
      </el-table-column>

      <el-table-column
          width="80"
          align="center"
          prop="statusText"
          label="状態"
          sortable>
      </el-table-column>

      <el-table-column
          width="80"
          align="center"
          prop="serviceTypeText"
          label="区分"
          sortable>
      </el-table-column>

      <el-table-column
          min-width="30"
          prop="name"
          label="取引契約名"
          sortable>
      </el-table-column>

      <el-table-column
          min-width="35"
          prop="tradeContractSource.dataComponentModelName"
          label="データ構成モデル名"
          sortable>
        <template #default="{row}">
          <table-inline>
            <text-field-like
                :value="row.tradeContractSource.dataComponentModelName"
                placeholder="未選択"
                hide-details
                dense>
            </text-field-like>
          </table-inline>
        </template>
      </el-table-column>

      <el-table-column
          width="130"
          prop="companionOwnerName"
          label="取引先事業者"
          sortable>
        <template #default="{row}">
          <table-inline v-if="row.companionTerminalName">
            <text-field-like
                style="font-size: 85%;"
                :value="row.companionTerminalName">
            </text-field-like>
          </table-inline>
          <table-inline>
            <text-field-like
                :value="row.companionOwnerName"
                :placeholder="'\u2E3B'">
            </text-field-like>
          </table-inline>
        </template>
      </el-table-column>

      <el-table-column
          width="160"
          prop="startDatetime"
          label="開始日時"
          sortable>
        <template #default="{row}">
          <table-inline>
            <text-field-like
                :value="formatDateTime(row.startDatetime)"
                placeholder="未設定">
            </text-field-like>
          </table-inline>
        </template>
      </el-table-column>

      <el-table-column
          width="160"
          prop="latestMessageCreatedAt"
          label="最新データ送受信日時"
          sortable>
        <template #header="{column}">
          <span style="font-size: 80%;">{{ column.label }}</span>
        </template>
        <template #default="{row}">
          <table-inline>
            <text-field-like
                :value="formatDateTime(row.latestMessageCreatedAt)"
                :placeholder="'\u2E3B'">
            </text-field-like>
          </table-inline>
        </template>
      </el-table-column>

      <el-table-column
          width="90"
          prop="tradeContractSource.messagesCount"
          label="取引数"
          sortable>
      </el-table-column>

      <el-table-column
          width="60"
          align="center"
          fixed="right">
        <template #default="{row}">
          <icon-btns>
            <icon-btn
                type="view"
                :to="{ name: alterRouteName('TradeResultShow'), params: { tradeContractId: row.id } }">
            </icon-btn>
          </icon-btns>
        </template>
      </el-table-column>
    </el-table>
  </tab-item-template>
</template>

<script>
import PathInfoMixin from "@/router/PathInfoMixin";
import TabItemTemplate from "@/components/templates/TabItemTemplate.vue";
import Formatter from "@/utils/Formatter";
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";
import TableInline from "@/components/atoms/TableInline.vue";
import IconBtns from "@/components/molecules/IconBtns";
import IconBtn from "@/components/molecules/IconBtn.vue";
import IoablePageMixin from "@/router/IoablePageMixin";
import {createTradeContractView} from "@/components/pages/contract/TradeContract/TradeContractView";
import TradeContractFilter from "@/components/organisms/TradeContractFilter.vue";

export default {
  name: 'TradeContractTable',
  mixins: [
    PathInfoMixin,
    Formatter,
    IoablePageMixin
  ],
  components: {
    TradeContractFilter,
    IconBtn,
    IconBtns,
    TabItemTemplate,
    TextFieldLike,
    TableInline
  },
  data() {
    return {
      tradeContracts: [],
      tradeContractFilter: () => true,
      searchForm: {
        currentUserTerminalRole: undefined,
      },
      queryForm: {
        nameContOrCompanionOwnerName: '',
      },
      filterText: '',
    }
  },
  computed: {
    tradeContractsView() {
      if (!this.queryForm.nameContOrCompanionOwnerName) {
        return this.tradeContracts;
      }
      return this.tradeContracts.filter(row =>
          row.name.indexOf(this.queryForm.nameContOrCompanionOwnerName) !== -1 ||
          row.companionOwnerName.indexOf(this.queryForm.nameContOrCompanionOwnerName) !== -1
      );
    },
    tradeContractsViewFiltered() {
      const textFilter = tc => {
        const f = this.filterText;
        if(f) {
          return tc.id.includes(f) ||
              tc.statusText?.includes(f) ||
              tc.name.includes(f) ||
              tc.tradeContractSource.dataComponentModelName?.includes(f) ||
              tc.companionOwnerName?.includes(f) ||
              tc.companionTerminalName?.includes(f) ||
              this.formatDateTime(tc.startDatetime)?.includes(f) ||
              this.formatDateTime(tc.latestMessageCreatedAt)?.includes(f);
        } else {
          return true;
        }
      };

      return this.tradeContractsView.filter(textFilter);
    },
  },
  methods: {
    async load() {
      const tradeContracts = await this.$store.dispatch('hcs/tradeContract/findResultList', {
        ...this.searchForm
      });
      this.tradeContracts = tradeContracts.map(tc => createTradeContractView(tc, this.$store));
    },
    handleFilterChanged(filters) {
      const {showProduce, showConsume} = filters;
      if (showProduce && showConsume) {
        this.searchForm.currentUserTerminalRole = undefined;
      } else if (showProduce && !showConsume) {
        this.searchForm.currentUserTerminalRole = 'producer';
      } else if (!showProduce && showConsume) {
        this.searchForm.currentUserTerminalRole = 'consumer';
      }

      const statuses = [];
      if(filters.showPublic) {
        statuses.push('public');
      }
      if(filters.showPrivate) {
        statuses.push('private');
      }
      if(filters.showTrading) {
        statuses.push('trading');
      }
      if(filters.showSuspended) {
        statuses.push('suspended');
      }
      if(statuses.length === 0) {
        this.tradeContracts = [];
      } else if (statuses.length === 4) {
        this.$set(this.searchForm, 'q[status_eq_any]', undefined);
      } else {
        this.$set(this.searchForm, 'q[status_eq_any]', statuses);
      }
    }
  },
  watch: {
    searchForm: {
      deep: true,
      handler() {
        this.load();
      }
    }
  }
}
</script>
